import { useMutation } from '@tanstack/react-query'

import { downloadPaymentRequestsCsvForPaymentRequestIdsSpecification } from '@src/api'
import { DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDownloadPaymentRequestsCsvForPaymentRequestIdsSpecification =
  () => {
    const { axiosInstance } = useAxios()
    return useMutation({
      mutationFn: (
        params: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
      ) =>
        downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(
          axiosInstance,
          params
        ),
    })
  }
